import { defer, MonoTypeOperatorFunction } from 'rxjs';

/**
 * Perform side-effects on subscription
 *
 * @param startupFn side-effect to perforn on subscription
 */
export function startup<T>(startupFn: () => void): MonoTypeOperatorFunction<T> {
    return (source$) =>
        defer(() => {
            startupFn();
            return source$;
        });
}
